import { useState , useEffect} from 'react';
import axios from 'axios';

export const useFetchRouting = () => {
    const [routingList, setRoutingList] = useState([]);
    const [isRouteLoading , setIsRouteLoading] = useState(false);
    
    useEffect(() => {
        const fetchRequest = async ()  =>{
            setIsRouteLoading(true);

            //JSON取得
            axios.get('/assets/json/routingDetailsData.json?'+(new Date()).getTime())
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res.data));
                    setRoutingList(data);
                })
                //.catch(() => setIsError(true))
                .finally(() => setIsRouteLoading(false));
        }
        fetchRequest();
    }, []); 

    return {routingList , isRouteLoading };
}
